﻿import { Output } from "@models/configurators/outputs/output";
import { FileOutput } from "@models/configurators/outputs/file-output";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { ICadOutput, IOutput } from "@models/entity-models";
import { eOutputType } from "@models/enums";
import { CadDrawingOutput } from "@models/configurators/outputs/cad-drawing-output";
import { Kbo, KboOutput } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";

@KboOutput(CToken.CadOutput,
    eOutputType.solidworks,
    eOutputType.autoCad,
    eOutputType.creo,
    eOutputType.creo3,
    eOutputType.inventor,
    eOutputType.salesforce
)
export class CadOutput extends FileOutput implements ICadOutput {
    constructor(kom: KbObjectManager, args?: IOutput) {
        super(kom, args);
    }
    public drawings: CadDrawingOutput[] = [];
    public partFamilyName: string;
    public newPartFamilyName: string;
    public material: string;
    public customMaterialDatabase: string;
    public modifyDimensionInAllConfig: boolean;

    public addDrawing() {
        let drw = new CadDrawingOutput(this.$manager);
        drw.name = "Drawing";
        this.$manager.addKbObject(drw, this);
        this.drawings.push(drw);
        return drw;
    }

    public removeDrawing(drawing: CadDrawingOutput) {
        this.drawings.remove(drawing);
        this.$manager.removeKbObject(drawing);
    }

    public removeOutput(drawing: CadDrawingOutput) {
        this.removeDrawing(drawing);
    }
}
